import Cookies from 'js-cookie'

export default {
    TOGGLE_DEVICE: (state, device) => {
        state.device = device
    },

    SET_LANGUAGE: (state, language) => {
        state.language = language
        Cookies.set('language', language)
    },

    SET_TOKEN: (state, token) => {
        state.token = token
        Cookies.set('token', token)
    },

    REMOVE_TOKEN: (state) => {
        state.token = null
        Cookies.remove('token')
    },

    SET_USER: (state, user) => {
        state.user = user
    },

    UPDATE_USER: (state, user) => {
        state.user = Object.assign({}, state.user, user)
    },

    SET_TYPE: (state, type) => {
        state.type = type
    },

    SET_FB: (state, fb) => {
        state.fb = fb
    },

    SET_GOOGLE: (state, google) => {
        state.google = google
    },

    SET_FIRST_NAME: (state, firstName) => {
        if (state.user) {
            state.user.firstName = firstName
        }
    },

    SET_LAST_NAME: (state, lastName) => {
        if (state.user) {
            state.user.lastName = lastName
        }
    },

    SET_PHONE_NUMBER: (state, phoneNumber) => {
        state.user.phoneNumber = phoneNumber
    },

    SET_TAX_ID: (state, taxId) => {
        state.user.taxId = taxId
    },

    SET_SHOW_MAIL: (state, isShowMail) => {
        state.isShowMail = isShowMail
    },

    SET_CARD_NUMBER: (state, cardNumber) => {
        state.user.cardNumber = cardNumber
    },

    SET_BALANCE: (state, balance) => {
        if (state.user) {
            state.user.balance = balance
        }
    },

    SET_PROMO_BALANCE: (state, promoBalance) => {
        if (state.user) {
            state.user.promoBalance = promoBalance
        }
    },

    SET_ACCOUNT_CONFIRMATION: (state, isConfirmed) => {
        state.isAccountConfirmed = isConfirmed
    },

    SET_COMPLETED_ACCOUNTS: (state, accounts) => {
        state.completedAccounts = accounts
    },

    SET_COMPLETED_BRANDS: (state, brands) => {
        state.completedBrands = brands
    },

    SET_COMPLETED_ESTABLISHMENTS: (state, establishments) => {
        state.completedEstablishments = establishments
    }
}
